module.exports = __webpack_public_path__ + "img/new-workspace.ef95b7c6.png";